import React from 'react'
import style from './PendingStores.css'

export const ResultUpdate = ({ result }) => (
    <div className="panel panel-info">
        <div className="panel-heading">Resultado actualización stocks de locales
            <span className="pull-right glyphicon glyphicon-info-sign"/>
        </div>
        <div className={`panel-body ${style.PendingStores_panelBody}`}>
            <div className="table-responsive">
                <table className={`table table-striped table-hover ${style.PendingStores_table}`}>
                    <thead>
                    <tr>
                        <th>Local</th>
                        <th>Inventario</th>
                        <th>Resultado</th>
                    </tr>
                    </thead>
                    <tbody>
                    {result.length === 0? <tr><td colSpan="3" style={{textAlign: 'center'}}>No se encontraron registros</td></tr> : null}
                    {result.map((local, index) => {
                        // construir el row con el resultado del local
                        let localTR = <tr key={index} className={local.error? 'danger' : ''}>
                            <td>{local.cliente} - {local.local}</td>
                            <td></td>
                            <td>{local.error? local.error : local.estado}</td>
                        </tr>
                        if(local.inventarios.length==0)
                            return localTR

                        // construir el row con el resultado de los inventarios asociados al local
                        let inventariosTR = local.inventarios.map((inv, index2)=>
                            <tr key={index+'--'+index2} className={inv.error? 'success' : ''}>
                                <td></td>
                                <td>{inv.fechaProgramada}</td>
                                <td>{inv.error? inv.error : inv.estado}</td>
                            </tr>
                        )
                        return [localTR, ...inventariosTR]
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./frontEnd/admin/stockStoreUpdate/components/ResultUpdate.jsx